import React from 'react';

const FeedSkeleton: React.FC = () => {
  return (
    <div className="space-y-4">
      {[1, 2, 3, 4].map((i) => (
        <div
          key={i}
          className="p-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg space-y-3"
        >
          {/* Header */}
          <div className="flex items-center justify-between mb-3 pb-3 border-b border-gray-100 dark:border-gray-700">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 bg-gray-300 dark:bg-gray-700 rounded-full flex-shrink-0 animate-fadePulse"></div>
              <div className="space-y-1">
                <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded w-24 animate-fadePulse"></div>
                <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded w-32 animate-fadePulse"></div>
              </div>
            </div>
            <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded w-16 animate-fadePulse"></div>
          </div>

          {/* Content */}
          <div className="space-y-2">
            <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded w-full animate-fadePulse"></div>
            <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded w-5/6 animate-fadePulse"></div>
            <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded w-4/6 animate-fadePulse"></div>
          </div>

          {/* Action */}
          <div className="pt-2">
            <div className="h-3 bg-gray-300 dark:bg-gray-700 rounded w-20 animate-fadePulse"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeedSkeleton;
